export const LOW_TRAFFIC_DEFAULT_THRESHOLD = 120960;
export const LOW_TRAFFIC_DEFAULT_ERROR_TOLERANCE = 250;
export const LOW_TRAFFIC_THRESHOLD_RANGE = [0, 250000000];

export const thresholdTooLowMessage = `The calculated value is less than our recommended threshold.
It may be too low to mitigate the low traffic issue.`;
